'use client'

import { useLayoutEffect } from 'react'
import { useLocation as useRouterLocation } from 'react-router-dom'

import { useBrowserNavigation } from '@marketplace-web/browser/browser-navigation-util'

const RequestLocationUpdater = () => {
  const { pathname, search, hash } = useRouterLocation()
  const { refreshUrl } = useBrowserNavigation()

  useLayoutEffect(() => {
    refreshUrl()
  }, [refreshUrl, pathname, search, hash])

  return null
}

export default RequestLocationUpdater
